import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Navigation } from './Navigation';
import Notification from './Notification';
export var Layout = function (_a) {
    var children = _a.children;
    return (_jsxs(_Fragment, { children: [_jsx(Navigation, {}), _jsx("div", { className: "flex flex-col pt-32 md:pt-40 px-6 md:px-0 container mx-auto", children: children }), _jsx(Notification, {})] }));
};
Layout.displayName = 'Layout';
